<div class="section is-fullheight" id="home">
  <div class="container has-text-centered">
    <Heading />
  </div>

  <div class="container has-text-centered">
    <div class="column is-4 is-offset-4">
      <div class="box mt-2">
        <form on:submit|preventDefault="{formSubmit}">
          <div class="field">
            <div class="control">
              {#if isDemo}
                <input
                  class="input is-large has-background-white-ter"
                  type="text"
                  name="name_demo"
                  placeholder="Dein Name"
                  autofocus=""
                  bind:value="{email}"
                  disabled="{processingLogin}"
                  autocomplete="on"
                />
              {:else}
                <input
                  class="input is-large has-background-white-ter"
                  type="email"
                  name="email"
                  placeholder="Deine Email-Adresse"
                  autofocus=""
                  bind:value="{email}"
                  disabled="{processingLogin}"
                  autocomplete="on"
                />
              {/if}
            </div>
          </div>

          <div class="field">
            <div class="control">
              {#if isDemo}
                <input
                  class="input is-large has-background-white-ter"
                  type="text"
                  name="password_demo"
                  placeholder="Passwort: BE/GOLF"
                  bind:value="{password}"
                  disabled="{processingLogin}"
                  autocomplete="off"
                />
              {:else}
                <input
                  class="input is-large has-background-white-ter"
                  type="password"
                  name="password"
                  placeholder="Dein Passwort"
                  bind:value="{password}"
                  disabled="{processingLogin}"
                  autocomplete="on"
                />
              {/if}
            </div>
          </div>
          <!-- <div class="field">
            <label class="checkbox">
              <input type="checkbox">
              Eingeloggt bleiben
            </label>
          </div> -->
          <button
            class="button is-block is-outlined is-large is-fullwidth {processingLogin ? 'is-loading' : ''}"
            disabled="{processingLogin}"
          >Login</button>
          {#if !isDemo}
            <div class="mt-2">
              <a
                href="/wp/wp-login.php?action=lostpassword"
                class="has-text-dark is-size-6"
              >Passwort vergessen?</a>
            </div>
          {/if}

          {#if isDemo && invalid}
            <p class="mt-3 has-text-grey">
              Login fehlgeschlagen. Probiere es mit deinem Namen ({demoData.username})
              und dem Passwort BE/GOLF
            </p>
          {/if}
          {#if !isDemo && invalid}
            <p class="mt-3 has-text-grey">
              {#if invalid == 'USER_NOT_EXISTING'}
                Dieser Benutzer existiert nicht. Möchtest du dich stattdessen
                <a on:click="{() => push('/registrieren')}"> >registrieren</a>?
              {:else if invalid == 'CLUB_DEPRECATED'}
                Dieser Dienst ist für diesen Golfclub leider nicht mehr
                verfügbar.
              {:else}
                {@html invalid}
              {/if}
            </p>
          {/if}
        </form>
      </div>
      {#if isDemo}
        <p>
          {#if showResetDemo}
            <div class="notification is-warning has-text-left">
              <p class="mb-4">
                Möchtest du die Demo zurücksetzen? Sämtliche Eingaben, sowie der
                gesamte Fortschritt geht dabei verloren.
              </p>
              <button
                class="button is-primary is-danger is-dark"
                on:click="{resetDemo}"
              >Ja</button>
              <button
                class="button is-outlined"
                on:click="{() => (showResetDemo = false)}"
              >Abbrechen</button>
            </div>
          {:else}
            <a
              on:click="{() => (showResetDemo = true)}"
              class="has-text-grey"
            >Demo zurücksetzen</a>
          {/if}
        </p>
      {:else}
        <div class="box mt-2">
          <div class="field">
            <div class="mb-2 is-size-6">Noch keinen Account?</div>

            <button
              on:click="{() => push('/registrieren')}"
              class="button is-block is-outlined is-large is-fullwidth"
            >Jetzt registrieren</button>
          </div>
        </div>
      {/if}
    </div>
  </div>
  <FooterNav />
</div>

<script>
import { push } from "svelte-spa-router";
import { club, demoSetup, loggedIn, userProgress } from "./stores";
import Heading from "./Heading.svelte";
import {
  demoSetupStoreKey,
  loginStoreKey,
  userProgressStoreKey,
} from "./constants";
import { onMount } from "svelte";
import { demoSvc } from "./services/demo.service";
import { authSvc, chaptersSvc } from "./services";
import FooterNav from "./FooterNav.svelte";

let clubData,
  demoData,
  up,
  email,
  password,
  processingLogin,
  invalid,
  showResetDemo;
const isDemo = demoSvc.isDemoInstance();
// if(!isDemo && location.href.indexOf('/golfclub-musterstadt/') !== -1) {
//   email = 'm+test@edenhauser.com';
//   password = 'Test123';
// }

const resetDemo = () => {
  demoSetup.set({});
  localStorage.removeItem(demoSetupStoreKey);
  sessionStorage.removeItem(loginStoreKey);
  sessionStorage.removeItem(userProgressStoreKey);
  push("/demo");
  location.reload();
};

const doLoginFailed = () => {
  loggedIn.set(false);
};
const doLoginSuccess = () => {
  loggedIn.set(true);
  invalid = false;
  if (up.skipIntro && up.skipManager) {
    push("/home");
  } else if (up.skipManager) {
    push("/manager");
  } else {
    push("/intro");
  }
};

const wpLogin = async () => {
  const result = await authSvc.login({ email, password });
  if (result.error) {
    doLoginFailed();
  } else {
    doLoginSuccess();
  }
  return result;
};

const formSubmit = async () => {
  processingLogin = true;
  if (isDemo) {
    setTimeout(() => {
      if (email === demoData.username && password == "BE/GOLF") {
        doLoginSuccess();
      } else {
        doLoginFailed();
      }
      processingLogin = false;
    }, 1000);
  } else {
    // Live Login
    const result = await wpLogin();
    if (result.error) {
      invalid = result.error;
    }
    processingLogin = false;
  }
};

onMount(() => {
  userProgress.subscribe((value) => {
    up = value;
  });

  demoSetup.subscribe((value) => {
    demoData = value;
    if (isDemo && !demoData?.username) {
      push("/demo");
    }
  });
  club.subscribe((data) => (clubData = data));
});
</script>

<style type="text/scss">
.notification p {
  font-weight: 400;
}
.hero.is-success {
  background: #f2f6fa;
}
.hero .nav,
.hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.box {
  margin-top: 5rem;
}

input {
  font-weight: 300;
}
p {
  font-weight: 700;
}
p.subtitle {
  padding-top: 1rem;
}

.login-hr {
  border-bottom: 1px solid black;
}

.has-text-black {
  color: black;
}

.field {
  padding-bottom: 10px;
}

.fa {
  margin-left: 5px;
}
</style>
